import { render, staticRenderFns } from "./StaffDialog.vue?vue&type=template&id=4f904e3f&scoped=true&"
import script from "./StaffDialog.vue?vue&type=script&lang=js&"
export * from "./StaffDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f904e3f",
  null
  
)

export default component.exports